<div class="assign-quests-container">
  <!-- Search and Filter Section -->
  <div class="search-filter-section">
    <div class="search-filter-row">
      <div class="search-field">
        <input
          type="text"
          id="searchQuests"
          [(ngModel)]="searchQuery"
          (input)="onSearchChange()"
          class="search-input"
          placeholder="Search Quests by name"
        />
      </div>
      <div class="filter-field">
        <input
          type="date"
          id="filterDate"
          [(ngModel)]="filterDate"
          (change)="onDateFilterChange()"
          class="filter-input"
          placeholder="Filter by date"
        />
      </div>
      <button
        type="button"
        class="assign-quests-btn"
        *ngIf="hasSelectedQuests()"
        (click)="onAssignQuestsTo()"
      >
        Assign Quests To
      </button>
    </div>
  </div>

  <!-- Quest Cards Section -->
  <div class="quests-list-section" *ngIf="filteredQuests.length">
    <div
      class="quest-card"
      *ngFor="let quest of filteredQuests"
    >
      <div class="quest-checkbox">
        <input
          type="checkbox"
          [id]="'quest-' + (quest.id || quest._id)"
          [checked]="isQuestSelected(quest.id || quest._id)"
          (change)="toggleQuestSelection(quest.id || quest._id)"
          class="checkbox-input"
        />
        <label
          [for]="'quest-' + (quest.id || quest._id)"
          class="checkbox-label"
        >
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="quest-thumbnail">
        <img
          *ngIf="quest.thumbnail"
          [src]="quest.thumbnail"
          [alt]="quest.name"
        />
      </div>
      <div class="quest-info">
        <div class="quest-title">{{ quest.name }}</div>
        <div class="quest-description">
          {{ quest.shortDescription }}
        </div>
        <div class="quest-meta">
          <span class="quest-sessions">
            {{ quest.sessions?.length || 0 }} Sessions
          </span>
          <span class="quest-created">
            Created on:
            {{ quest.createdDateTime | date: 'MMMM d, y' }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="filteredQuests.length === 0">
    <p>No quests found matching your search criteria.</p>
  </div>
</div>

<!-- Assign Quests Modal -->
<div class="modal-backdrop" *ngIf="showAssignModal" (click)="closeAssignModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Assign Quests To:</h2>
      <button type="button" class="modal-close-btn" (click)="closeAssignModal()">
        <span>&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <!-- Search Section -->
      <div class="member-search-section">
        <div class="member-search-row">
          <input
            type="text"
            [(ngModel)]="memberSearchName"
            (input)="onMemberSearchChange()"
            class="member-search-input"
            placeholder="Search By Name"
          />
          <input
            type="text"
            [(ngModel)]="memberSearchEmail"
            (input)="onMemberSearchChange()"
            class="member-search-input"
            placeholder="Search By Email"
          />
          <button
            type="button"
            class="assign-quests-modal-btn"
            [disabled]="selectedMemberIds.size === 0"
            (click)="onAssignQuests()"
          >
            Assign Quests
          </button>
        </div>
      </div>

      <!-- Loading State -->
      <div class="loading-state" *ngIf="isLoadingMembers">
        <p>Loading members...</p>
      </div>

      <!-- Members Table -->
      <div class="members-table-container" *ngIf="!isLoadingMembers">
        <table class="members-table">
          <thead>
            <tr>
              <th></th>
              <th>Name</th>
              <th>Email</th>
              <th>Age</th>
              <th>Number of Quest Assigned</th>
              <th>Quest Completed</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let member of filteredMembers">
              <td>
                <div class="member-checkbox-wrapper">
                  <input
                    type="checkbox"
                    [id]="'member-' + member.memberId"
                    [checked]="isMemberSelected(member.memberId)"
                    (click)="toggleMemberSelection($event, member.memberId)"
                    class="member-checkbox-input"
                  />
                  <label
                    [for]="'member-' + member.memberId"
                    class="member-checkbox-label"
                  >
                    <span class="member-checkmark"></span>
                  </label>
                </div>
              </td>
              <td>{{ member.name }}</td>
              <td>{{ member.email }}</td>
              <td>{{ member.age }}</td>
              <td>{{ member.numberOfQuestAssigned }}</td>
              <td>{{ member.questCompleted }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Empty State -->
        <div class="empty-members-state" *ngIf="filteredMembers.length === 0">
          <p>No members found matching your search criteria.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Warning Card for Overlapping Quests -->
<div class="warning-card-backdrop" *ngIf="showWarningCard" (click)="cancelSelection()">
  <div class="warning-card" (click)="$event.stopPropagation()">
    <div class="warning-card-header">
      <h3 class="warning-title">Quest Already Ongoing</h3>
      <button type="button" class="warning-close-btn" (click)="cancelSelection()">
        <span>&times;</span>
      </button>
    </div>
    <div class="warning-card-body">
      <p class="warning-message">
        The following quest{{ overlappingQuests.length !== 1 ? 's are' : ' is' }} already ongoing for <strong>{{ warningMember?.name }}</strong>:
      </p>
      <ul class="overlapping-quests-list">
        <li *ngFor="let quest of overlappingQuests">
          {{ quest.questName }}
        </li>
      </ul>
    </div>
    <div class="warning-card-actions">
      <button type="button" class="warning-ok-btn" (click)="cancelSelection()">
        OK
      </button>
    </div>
  </div>
</div>

<!-- Success Modal -->
<div class="modal-backdrop" *ngIf="showSuccessModal" (click)="closeSuccessModal()">
  <div class="success-modal-content" (click)="$event.stopPropagation()">
    <div class="success-icon">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32" cy="32" r="32" fill="#28a745"/>
        <path d="M20 32L28 40L44 24" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <h2 class="success-title">Quests Assigned</h2>
    <p class="success-message">
      The selected quests has been assigned to {{ assignedMembersCount }} member{{ assignedMembersCount !== 1 ? 's' : '' }} that you have selected, To make any changes go to the selected member dashboard
    </p>
    <button type="button" class="continue-btn" (click)="closeSuccessModal()">
      Continue
    </button>
  </div>
</div>

